var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-page"},[_c('div',{staticClass:"top-title"},[_vm._v("安全知识竞答系统")]),_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("./img/jingda/1.jpg")}})]),_c('div',{staticClass:"text-content"},[_vm._v("\n    以现代信息技术为手段，劳务工人通过安全知识答题系统进入无纸化答题，以闯关的形式，寓教于乐，答题成绩后台存档，可根据答题成绩设置奖项，变“被动学习”为“主动参与”，可应用于智慧工地展馆，安全教育展厅等多个场所。\n  ")])])
}]

export { render, staticRenderFns }